export default "__VITE_ASSET__CRuJ9ESR__"